import type { GlobalConfig } from '@atlassian/jira-servicedesk-insight-global-configuration-store/src/common/types.tsx';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { getResourceStore } from '@atlassian/react-resource-router';
import { extractResourceStatePromise } from '@atlassian/jira-router-resources-assets-admin-settings/src/common/utils.tsx';
import { transformAssetsPermissionResponse, getAssetsGlobalConfigUrl } from '../common/utils.tsx';
import type { AssetsPermissionResponse } from '../common/types.tsx';
import { emptyAssetsPermissionResponse } from '../common/constants.tsx';

/**
 * Shared service to check if a user has Assets permissions
 * Used by both the router resource and utility functions
 */
const HEADER_X_SSR_SERVICE_NAME = 'x-ssr-service-name';
const HEADER_ATL_WORKSPACEID = 'atl-workspaceid';
export const checkAssetsPermission = async (): Promise<AssetsPermissionResponse> => {
	const { storeState } = getResourceStore();
	const state = storeState.getState();

	try {
		const workspaceId = await extractResourceStatePromise(state.data);

		if (!workspaceId || typeof workspaceId !== 'string') {
			fireErrorAnalytics({
				meta: {
					id: 'checkAssetsPermission',
					packageName: 'jiraRouterResourcesAssetsUserPermission',
					teamName: 'aurum',
				},
				error: new Error('Workspace ID is missing or not a string'),
			});
			return emptyAssetsPermissionResponse;
		}

		const response = await performGetRequest<GlobalConfig>(getAssetsGlobalConfigUrl(workspaceId), {
			headers: {
				[HEADER_X_SSR_SERVICE_NAME]: 'jsm-cmdb-gateway',
				[HEADER_ATL_WORKSPACEID]: workspaceId,
			},
		});

		return transformAssetsPermissionResponse(response, true);

		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			meta: {
				id: 'checkAssetsUserPermission',
				packageName: 'jiraRouterResourcesAssetsUserPermission',
				teamName: 'aurum',
			},
			error,
		});
		return emptyAssetsPermissionResponse;
	}
};

export default checkAssetsPermission;
